(function () {
  const COMPONENT = "qld__toggle-tip";
  const TRIGGER_SEL = "." + COMPONENT + "-trigger";
  const CONTENT_SEL = "." + COMPONENT + "-content";
  const VISIBLE = COMPONENT + "-visible";
  const MARGIN = 8;

  // Tracks triggers we’ve already wired; auto-GC when elements are removed
  const known = new WeakSet();

  // Track the currently opened dynamic tip (so our own doc handlers can close it)
  let currentTip = null;
  let currentTrigger = null;
  let docBound = false;

  function seedKnown() {
    document.querySelectorAll(TRIGGER_SEL).forEach(el => known.add(el)); // existing ones bound by the library
  }

  function isOpen(content) {
    return content && content.classList.contains(VISIBLE);
  }

  function closeAll() {
    const triggers = document.querySelectorAll(TRIGGER_SEL);
    currentTip = null;
    currentTrigger = null;
    QLD.toggleToolTips.closeAllToggleToolTips(COMPONENT, triggers);
  }

  function ensureDocHandlers() {
    if (docBound) return;
    document.addEventListener("click", function (e) {
      if (!currentTip) return;
      const content = currentTip.querySelector(CONTENT_SEL);
      if (content && !content.contains(e.target)) closeAll();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !currentTip) return;
      const content = currentTip.querySelector(CONTENT_SEL);
      if (isOpen(content)) {
        const t = currentTrigger;
        closeAll();
        t && t.focus();
      }
    });
    docBound = true;
  }

  function bindTrigger(trigger) {
    if (!trigger || known.has(trigger)) return;
    known.add(trigger);

    const tipId = trigger.getAttribute("data-target");
    if (!tipId) return;

    const tip = document.getElementById(tipId);
    if (!tip) return;

    const content = tip.querySelector(CONTENT_SEL);
    if (!content) return;

    const link = content.querySelector("a");

    const open = () => {
      currentTip = tip;
      currentTrigger = trigger;
      QLD.toggleToolTips.openToggleToolTip(COMPONENT, tip, trigger, MARGIN);
    };
    const close = () => {
      QLD.toggleToolTips.closeToggleToolTip(COMPONENT, tip, trigger);
    };

    trigger.addEventListener("click", function (e) {
      const wasCurrent = currentTip === tip;
      closeAll();
      if (isOpen(content) || wasCurrent) close();
      else open();
      e.stopPropagation();
    });

    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Tab" && isOpen(content)) {
        e.preventDefault();
        if (link) link.focus(); else close();
        e.stopPropagation();
        return;
      }
      if (e.key === "Enter" || e.key === " " || e.keyCode === 32) {
        e.preventDefault();
        const wasCurrent = currentTip === tip;
        if (isOpen(content)) {
          close();
        } else {
          closeAll();
          if (isOpen(content) || wasCurrent) close(); else open();
        }
        e.stopPropagation();
      }
    });

    if (link) {
      link.addEventListener("keydown", function (e) {
        if (e.key === "Tab" || e.key === "Escape") {
          e.preventDefault();
          close();
          trigger.focus();
        }
      });
    }

    ensureDocHandlers();
  }

  // Public: call after you insert dynamic HTML
  window.initNewTriggers = function (scopeOrTrigger) {
    if (!scopeOrTrigger) return;
    if (scopeOrTrigger.matches?.(TRIGGER_SEL)) {
      bindTrigger(scopeOrTrigger);
    } else {
      scopeOrTrigger.querySelectorAll?.(TRIGGER_SEL)?.forEach(bindTrigger);
    }
  };

  // Seed with existing triggers (already bound by the library’s DOMContentLoaded init)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", seedKnown, { once: true });
  } else {
    seedKnown();
  }
})();